import { useCallback, useState } from 'react';
import { store } from '../../../../../store';

const map = {
  defconCacheRefresh: {
    path: '/force-refresh',
    data: { ignore_s3_cache: true },
    context: { headersToOverride: ['authorization'] }
  },
  defconCacheRefreshAndSignal: {
    path: '/force-refresh',
    data: { ignore_s3_cache: true, send_start_signal: true }
  },
  defconForceBrowserRefresh: {
    path: '/commands',
    data: { type: 'reload', params: {}, autoplay: false, regular: true }
  },
  defconForceEndStream: {
    path: '/force_end',
    data: { ignore_s3_cache: true }
  },
  defconNuclearRefresh: {
    path: '/force-refresh',
    data: { ignore_s3_cache: true, send_start_signal: true, refresh_assets: true }
  }
};

export const useDefcon = (type: keyof typeof map): [
  (cid: string) => Promise<{ success: boolean } | undefined>,
  { loading: boolean; error: Error | undefined }
] => {
  const [{ WEBPLAYER_CONTROL_URI}, token] = store((v) => [v.environment, v.token]);

  void WEBPLAYER_CONTROL_URI;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error>();

  return [
    useCallback(async (cid: string) => {
    const request = map[type];
    let data: { success: boolean } | undefined;

    setLoading(true);

    try {
      const response = await fetch(`${WEBPLAYER_CONTROL_URI}/api/v1/clients/${cid}${request.path}`, {
        method: 'post',
        body: JSON.stringify(request.data),
        headers: [
          ['Authorization', `Bearer ${token?.jwt ?? ''}`],
          ['Content-type', 'application/json']
        ]
      });

      if (!response.ok) {
        throw new Error(response.statusText);
      }

      const data_ = <{ success: boolean }>(await response.json());

      data = data_;
    } catch(error_: unknown) {
      setError(<Error>error_);
    }

    setLoading(false);

    return data;
  }, [WEBPLAYER_CONTROL_URI, token?.jwt, type]),
  {
    loading,
    error
  }
];
};
